import {
  SxProps,
  Theme,
  Typography,
  TypographyProps,
  useTheme
} from '@mui/material'
import React from 'react'
import { AvailabilityDataList } from 'src/api'
import { useMuiTheme } from 'src/config'

interface Props extends Pick<TypographyProps, 'onClick'> {
  availabilityData?: AvailabilityDataList
}

const useAvailabilityColors = ({ availabilityData }: Props): SxProps<Theme> => {
  const { isDarkMode } = useMuiTheme()
  const { palette } = useTheme()

  const { availables, block, ownerChannel } = availabilityData ?? {}
  const isAvailable = availables && availables > 0

  const circleStyles = {
    backgroundColor: isDarkMode ? 'white' : palette.primary.main,
    color: isDarkMode ? 'black !important' : 'white !important',
    borderRadius: '100%',
    display: 'grid',
    placeItems: 'center',
    width: '2.2rem',
    lineHeight: '2.2rem'
  }

  if (isAvailable && block) {
    return { ...circleStyles, backgroundColor: '#686868' }
  }

  if (!isAvailable && block) {
    return { ...circleStyles, backgroundColor: '#ee5858' }
  }

  if (isAvailable && ownerChannel) {
    return { ...circleStyles, backgroundColor: '#eae23f', color: 'black' }
  }

  if (!isAvailable && ownerChannel) {
    return { ...circleStyles, backgroundColor: '#9610ad' }
  }

  if (availables === 0) {
    return circleStyles
  }

  return {}
}

const RatesGridTypeAvailablesCell: React.FC<Props> = ({
  availabilityData,
  onClick
}) => {
  const availabilityStyles = useAvailabilityColors({ availabilityData })

  return (
    <Typography
      sx={{
        cursor: 'help',
        ...availabilityStyles
      }}
      onClick={onClick}
    >
      {availabilityData?.availables}
    </Typography>
  )
}
export default RatesGridTypeAvailablesCell
